import React, { useLayoutEffect, useState } from 'react';
import clsx from 'clsx';

import Button from '@common/Button';
import Container from '@common/Container';
import Section from '@common/Section';
import Img from '@common/Image';
import Row from '@common/Row';
import RichText from '@common/RichText';

import * as styles from '@styles/modules/block.module.scss';

const FloatingIcons = ({ data }) => {
  const {
    title,
    showTitle,
    text,
    listClass,
    imagePosition,
    imagePositionTop,
    buttons,
    images,
    topMargin,
    bgColour,
    bgFullwidth
  } = data;
  const [topImg, setTopImg] = useState(null);
  const [bottomImg, setBottomImg] = useState(null);
  useLayoutEffect(() => {
    setTopImg(images[0]);
    setBottomImg(images[1]);
  },[images])
  return (
    <Section className={clsx('position-relative', topMargin, {
        [`bg-${bgColour}`]: bgColour,
        'py-3': bgColour,
        ['container']: !bgFullwidth
      })}>
      <Container>
        {(showTitle && title) && <h2 className='text-center mb-3 col-lg-10 mx-auto'>{title}</h2>}
        <Row className={clsx(`d-flex flex-column flex-md-row justify-content-center align-items-center`, {
            'flex-column-reverse': imagePositionTop
          })}>
          {(text || buttons) &&
            <div className='col text-center col-lg-10'>
              {text &&
                <RichText
                  json={text}
                  h1='mb-3'
                  h2='mb-3'
                  ul={listClass}
                  p='mb-3'
                  li='py-2'
                />
              }
              {buttons && 
                <div className='d-flex flex-row mb-3 justify-content-center'>
                  {buttons.map(button => (
                    <Button
                      key={button.id}
                      to={button.link}
                      variant={button.variant}
                      size={button.size}
                      addClass={button.class}
                      copy={button.copy}
                      modal={button.modal}
                    />
                  ))}
                </div>
              }
            </div>
          }
        </Row>
        {topImg &&
          <Img
            className={clsx('position-absolute', styles.sectionHeadingDecal, {
              [styles.sectionHeadingDecalTopLeft]:imagePosition === 'Left',
              [styles.sectionHeadingDecalTopRight]:imagePosition === 'Right',
            })}
            image={topImg.gatsbyImageData}
            file={topImg.file}
            alt={topImg.description}
          />
        }
        {bottomImg &&
          <Img
            className={clsx('position-absolute', styles.sectionHeadingDecal, {
              [styles.sectionHeadingDecalBottomLeft]:imagePosition === 'Right',
              [styles.sectionHeadingDecalBottomRight]:imagePosition === 'Left',
            })}
            image={bottomImg.gatsbyImageData}
            file={bottomImg.file}
            alt={bottomImg.description}
          />
        }
      </Container>
    </Section>
  )
}

export default FloatingIcons
